var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"p-shopIotStatus"},_vm._l((_vm.computedDataList),function(item){return _c('li',{key:item.label,staticClass:"p-shopIotStatus__item"},[_c('PShopGraph',{attrs:{"data":item,"rendered-at":_vm.renderedAt,"range":_vm.selectedRange}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }